export enum TimelineViewTypeSR {
    Day = <any>'Dan',
    Week = <any>'Nedelja',
}
